import { render, staticRenderFns } from "./course_subscribe_detail.vue?vue&type=template&id=b02b5e4e&scoped=true&"
import script from "./course_subscribe_detail.vue?vue&type=script&lang=js&"
export * from "./course_subscribe_detail.vue?vue&type=script&lang=js&"
import style0 from "./course_subscribe_detail.vue?vue&type=style&index=0&id=b02b5e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02b5e4e",
  null
  
)

export default component.exports